module.exports = __webpack_public_path__ + "static/fonts/Inter-Regular.515cae74.ttf";